'use strict';
module.exports = typeof navigator !== 'undefined' &&
	(/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion));



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-iexplorer/index.js
// module id = 1343
// module chunks = 2